<template>
  <div class="admin-home">
    <div class="container">
      <div class="row justify-content-center justify-content-md-start">
        <div class="col-6 col-md-4 col-lg-2">
          <img src="../../assets/images/riks-logo.png" class="img-fluid " alt="SMASK Göteborg">
        </div>
      </div>
      <div class="row pt-5">
        <div class="col-12 col-lg-6">
          <h1>Settings</h1>

          <div v-if="settings">
            <div class="form-group">
              <label>Läge</label>

              <div class="btn-group d-block" role="group">
                <button type="button" class="btn btn-secondary text-uppercase" v-for="mode in availableModes" :key="mode" :disabled="loading" :class="{ 'btn-success': mode === settings.mode, 'btn-secondary': mode !== settings.mode }" @click="setMode(mode)">{{ mode }}</button>
              </div>
              <small class="form-text text-muted">Jag ändras direkt, du behöver inte klicka på "Spara" för att sätta läge.</small>
            </div>

            <form name="settingsForm" method="post" @submit.prevent="saveSettings" v-if="settings">
              <fieldset :disabled="loading">
                <div class="form-group">
                  <label>Stream-länk</label>

                  <input type="text" name="streamUrl" id="streamUrl" v-model="settings.streamUrl" class="form-control">

                  <div class="embed-responsive embed-responsive-16by9 border my-2" v-if="previewStreamUrl">
                    <div class="embed-responsive-item d-flex flex-column align-items-center justify-content-center">
                      <jwplayer :stream-url="settings.streamUrl"></jwplayer>
                    </div>
                  </div>

                  <small class="form-text text-muted">Denna används i spelaren på sidan.
                    <a href="javascript:;" @click="togglePreviewStreamUrl()" v-if="settings.streamUrl">
                      <span v-if="!previewStreamUrl">Visa förhandsvisning</span>
                      <span v-if="previewStreamUrl">Dölj förhandsvisning</span>
                    </a>
                  </small>
                </div>

                <div class="form-group">
                  <label for="startAt">Startar</label>
                  <input type="text" name="startAt" id="startAt" v-model="settings.startAt" class="form-control">
                  <small class="form-text text-muted">Enligt YYYY-MM-DDTHH:MM:SS.sssZ (UTC JavaScript ISO-sträng)</small>
                </div>

                <div class="form-group">
                  <label for="scoreboardFontSize">Textstorlek, Scoreboard</label>
                  <input type="text" name="scoreboardFontSize" id="scoreboardFontSize" v-model="settings.scoreboardFontSize" class="form-control">
                  <small class="form-text text-muted">Enligt <code>rem</code>. Default: <code>4.375</code>. Just nu: {{ sizeAsPx }} pixlar.</small>
                </div>

                <button type="submit" class="btn btn-success">Spara</button>
              </fieldset>
            </form>
          </div>
        </div>
        <div class="col-12 col-lg-6 mt-5 mt-lg-0">
          <div class="row align-items-center">
            <div class="col"><h1 class="m-0">Bidrag & poäng</h1></div>
            <div class="col-auto"><button type="button" class="btn btn-primary" @click="addContribution">Lägg till bidrag</button></div>
          </div>

          <div class="row align-items-center mb-2">
            <div class="col small">
              Ändra namn genom att ändra namn och klicka på spara.<br>
              Ta bort bidrag genom att klicka på "X".<br>
              Lägg till och ta bort poäng genom att klicka på "+/-".<br><br>

              <a href="/scoreboard" target="_blank">Klicka på mig för att öppna resultattavlan</a>
            </div>
          </div>

          <contribution v-for="(contribution, index) in sortedContributions" :key="`key_${index}_${contribution.updatedAt}`" :data="contribution" :index="index"></contribution>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"
  import orderBy from "lodash/orderBy"

  import Jwplayer from "@/components/jwplayer"
  import Contribution from "./components/contribution.vue"

  export default {
    name: "admin-home",
    components: { Jwplayer, Contribution },
    data: () => {
      return {
        loading: true,
        previewStreamUrl: false,
        availableModes: ["offline", "pre", "live", "post"],
        settings: null,
        contributions: [],
      }
    },
    computed: {
      sortedContributions() {
        return orderBy(this.contributions, ["sortOrder"], ["asc"])
      },
      sizeAsPx() {
        let rem = parseFloat(this.settings.scoreboardFontSize)
        return (isNaN(rem) ? 4.375 : rem) * 16
      }
    },
    methods: {
      togglePreviewStreamUrl() {
        this.previewStreamUrl = !this.previewStreamUrl
      },
      async addContribution() {
        let name = prompt("Namn", "")

        if (name != null && name.length > 0) {
          let contributionRef = await firebase.firestore().collection(`contributions`).doc()
          contributionRef.set({
            name: name,
            points: [],
            sortOrder: this.contributions.length,
            updatedAt: firebase.firestore.FieldValue.serverTimestamp(),
          })
        }
      },
      async saveSettings() {
        this.loading = true

        let settingsRef = await firebase.firestore().collection(`application`).doc(`settings`)
        settingsRef.update(this.settings)

        this.loading = false
      },
      async setMode(mode) {
        this.loading = true

        let settingsRef = await firebase.firestore().collection(`application`).doc(`settings`)
        await settingsRef.update({ mode: mode })
        
        this.loading = false
      },
    },
    async mounted() {
      await this.$bind("settings", firebase.firestore().collection(`application`).doc(`settings`))
      await this.$bind("contributions", firebase.firestore().collection(`contributions`))

      this.loading = false
    }
  }
</script>
